module.exports = __webpack_public_path__ + "static/media/LogoCircle.884d17b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LogoCircle.png
// module id = 852
// module chunks = 0